(function () {
  const STORAGE_KEY = 'lavespera_timed_popup_shown';

  class LavesperaTimedPopup {
    constructor(overlay) {
      this.overlay = overlay;
      this.closeBtn = overlay.querySelector('.lavespera-timed-close');
      this.delay = parseInt(overlay.dataset.delay || '10', 10) * 1000;
      this.showOnce = overlay.dataset.showOnce === 'true';
      this.bind();
      this.maybeSchedule();
    }

    bind() {
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.overlay.classList.contains('is-active')) {
          this.close();
        }
      });
    }

    maybeSchedule() {
      if (this.showOnce && sessionStorage.getItem(STORAGE_KEY) === 'true') return;
      if (window.Shopify && Shopify.designMode) return;
      setTimeout(() => this.open(), this.delay);
    }

    open() {
      this.overlay.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      if (this.showOnce) sessionStorage.setItem(STORAGE_KEY, 'true');
    }

    close() {
      this.overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  }

  function init(root) {
    const el = (root || document).querySelector('#lavesperaTimedPopup');
    if (el && !el.dataset.initialized) {
      el.dataset.initialized = 'true';
      window.lavesperaTimedPopup = new LavesperaTimedPopup(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:select', (e) => {
    const el = e.target.querySelector('#lavesperaTimedPopup');
    if (el && window.lavesperaTimedPopup) window.lavesperaTimedPopup.open();
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    const el = e.target.querySelector('#lavesperaTimedPopup');
    if (el && window.lavesperaTimedPopup) window.lavesperaTimedPopup.close();
  });
})();
